import React, { Fragment, useCallback, useEffect, useState } from "react";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";
import { Breadcrumbs, P } from "../../../AbstractElements";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import CreateSubServiceModal from "./components/createSubServicesModal";
import CreateFormModal from "./components/createFormModal";
import { getAllSubServices } from "../../../store/slices/subServicesSlice";
import FeatherIcon from "feather-icons-react";
import SubServiceDetails from "../SubServices/SubserviceDetails";
import { useDebounce } from "../../../Hooks/useDebounce";
const SubServicesTable = () => {
  const history = useNavigate();
  const serviceDetails = useSelector((state) => state.services.serviceDetail);

  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [totalCount, setCount] = useState(0);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isCreateSubServiceModalOpen, setIsCreateSubServiceModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const debouncedSearch = useDebounce(searchQuery, 300);
  const [sorting, setSorting] = useState([]);
  const [columnFilters, setColumnFilters] = useState([]);
  const columnFilterSearch = useDebounce(columnFilters, 300);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [selectedForm, setSelectedForm] = useState({});
  const [selectedSubService, setSelectedSubService] = useState(null);
  const client = useSelector((state) => state.clients?.selectedClient?.value);

  const fetchData = async (payload) => {
    const sortField = sorting.length > 0 ? sorting[0].id : undefined;
    const sortOrder = sorting.length > 0 ? (sorting[0].desc ? "desc" : "asc") : undefined;
    
    const queryPayload = {
      pagination: true,
      limit: pageSize,
      offset: page * pageSize,
      ...(sortField && { sortBy: sortField }),
      ...(sortOrder && { sortOrder: sortOrder }),
      ...payload,
    };
    
    const res = await dispatch(getAllSubServices(queryPayload));
    if (res?.payload) {
      const p = res.payload;
      setData(p.subServicesData || p.subServices || p.data || p.result || []);
      setCount(p.count !== undefined ? p.count : (p.total !== undefined ? p.total : 0));
    }
  };

  useEffect(() => {
    fetchData({ search: debouncedSearch, filters: columnFilterSearch });
  }, [dispatch, page, pageSize, debouncedSearch, columnFilterSearch, sorting, serviceDetails]);

  const getSubServices = () => {
    fetchData({ search: debouncedSearch, filters: columnFilterSearch });
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "ID",
        header: "ID",
        size: 150,
      },
      {
        accessorKey: "name",
        header: "Sub Service Name",
        size: 150,
      },
      {
        accessorKey: "description",
        header: "Description",
        size: 150,
      },
      {
        accessorKey: "type",
        header: "Benefit Type",
        size: 150,
      },
      // {
      //   accessorKey: "actions",
      //   header: "Actions",
      //   size: 150,
      //   Cell: ({ row }) => (
      //     <div>
      //       {" "}
      //       <FeatherIcon
      //         icon="edit"
      //         size={15}
      //         className="w-10 text-primary cursor-pointer"
      //         onClick={() => {
      //           ToggleForm(row);
      //         }}
      //       />
      //     </div>
      //   ),
      // },
      // {
      //   accessorKey: "upload",
      //   header: "Upload Image",
      //   size: 150,
      //   Cell: ({ row }) => (
      //     <FeatherIcon
      //       icon="upload"
      //       color="primary"
      //       onClick={() => {
      //         setSelectedSubService(row.original);
      //       }}
      //     >
      //       Upload
      //     </FeatherIcon>
      //   ),
      // },
    ],
    [],
  );

  const handlePageChange = (event) => {
    const newState = typeof event === "function" ? event({ pageIndex: page, pageSize: pageSize }) : event;
    setPage(newState.pageIndex);
    setPageSize(newState.pageSize);
  };

  const handleOnChangeSearch = (value) => {
    setSearchQuery(value);
    setPage(0);
  };

  const table = useMaterialReactTable({
    columns,
    data,
    initialState: { density: "compact" },
    // muiTableBodyRowProps: ({ row }) => ({
    //   onClick: (event) => rowAction(event, row),
    //   sx: {
    //     cursor: "pointer",
    //   },
    // }),
    renderTopToolbarCustomActions: ({ table }) => (
      <div className="d-flex">
        <div
          sx={{
            display: "flex",
            gap: "16px",
            padding: "8px",
            flexWrap: "wrap",
          }}
        >
          <button
            className="btn bg-primary"
            disabled={client === "ts"}
            onClick={() => setIsCreateSubServiceModalOpen(true)}
          >
            Create Sub Service
          </button>
        </div>
      </div>
    ),
    manualPagination: true,
    manualSorting: true,
    manualFiltering: true,
    rowCount: totalCount || 0,
    onPaginationChange: handlePageChange,
    onSortingChange: setSorting,
    onColumnFiltersChange: setColumnFilters,
    state: {
      pagination: { pageIndex: page, pageSize: pageSize },
      sorting,
      columnFilters,
      globalFilter: searchQuery,
    },
    onGlobalFilterChange: handleOnChangeSearch,
  });

  const toggle = useCallback(() => {
    setModalOpen(!isModalOpen);
  }, [isModalOpen]);

  const ToggleForm = (row) => {
    setSelectedSubService(row?.original);
    setSelectedForm(row?.original?.ServiceForms);
    setModalOpen(!isModalOpen);
    // }
  };

  return (
    <Fragment>
      {/* <CreateFormModal
        isOpen={isModalOpen}
        toggle={toggle}
        editForm={
          selectedForm?.formFields ? JSON.parse(selectedForm?.formFields) : []
        }
        formData={selectedForm}
        selectedSubService={selectedSubService}
      ></CreateFormModal> */}
      <CreateSubServiceModal
        isOpen={isCreateSubServiceModalOpen}
        toggle={() =>
          setIsCreateSubServiceModalOpen(!isCreateSubServiceModalOpen)
        }
        onSubServiceCreated={() => getSubServices()}
      ></CreateSubServiceModal>
      <Breadcrumbs
        mainTitle="Sub Services"
        parent="Sub Services"
        parentPath="sub-services"
        title="Sub Services List"
      />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <MaterialReactTable table={table} />
            </Card>
          </Col>
        </Row>
        {/* {selectedSubService && (
          <Row>
            <Col sm="12">
              <SubServiceDetails
                subService={selectedSubService}
                onClose={() => setSelectedSubService(null)}
              />
            </Col>
          </Row>
        )} */}
      </Container>
    </Fragment>
  );
};

export default SubServicesTable;
